

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const bankVerifyAction = createAsyncThunk(
    'bank-verify',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/bank/verify`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const bankVerifySlice = createSlice({
    name: 'bank-verify',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(bankVerifyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(bankVerifyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })
            builder.addCase(bankVerifyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },

})



export const bankVerifyReducer = bankVerifySlice.reducer    






// router.put("/bank/verify", new Banks().bankVerify)